"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Badge = void 0;
var _mui = require("@ori-ui/mui");
const Badge = exports.Badge = (0, _mui.styled)('div')(({
  ownerState: {
    isIcon
  },
  theme
}) => ({
  alignItems: 'center',
  background: theme.palette.offer.light,
  borderRadius: '50%',
  color: theme.palette.offer.main,
  display: 'flex',
  fontSize: isIcon ? '2.5rem' : '1.2rem',
  height: 45,
  justifyContent: 'center',
  left: -10,
  position: 'absolute',
  top: -7,
  width: 45,
  zIndex: 1,
  [theme.breakpoints.only('xs')]: {
    fontSize: isIcon ? '1.5rem' : '1rem',
    height: isIcon ? 30 : 40,
    left: -5,
    width: isIcon ? 30 : 40
  }
}));